import {Checkbox, FormControlLabel, FormGroup} from "@mui/material";
import React, {useState} from "react";
import {ProjectRoles, RoleSet, Roles as RolesType, RoleTypes, Projects} from "../../redux/types/firebase";
import {connect} from "react-redux";

interface Props {
    onRolesChange: (roles: RolesType) => void
    roles: RolesType
}

export function DescribeRoles(roles: RolesType, projects: Projects): string {
    return Object.keys(roles || {}).map((key: string) => {
        if (["admin", "editor", "viewer", "reviewer"].includes(key)) {
            if ((roles as RoleSet)[key as keyof RoleSet]) {
                return key;
            }
        } else {
            const projectRoles = roles as ProjectRoles;

            return Object.keys(projectRoles[key]).map((role) => {
                if (projects[key] && projectRoles[key][role as RoleTypes]) {
                    return `${projects[key].name}: ${role}`;
                }
                return undefined;
            }).filter(key => key !== undefined).join(", ");
        }
        return undefined;
    }).filter(key => key).join(", ");
}

function Roles({onRolesChange, roles}: Props) {
    const [displayRoles, setDisplayRoles] = useState(roles);
    const handleCheckboxChange = ({currentTarget}: React.ChangeEvent<HTMLInputElement>) => {
        const role = currentTarget.dataset.role as RoleTypes;

        if (role) {
            const newRoles = {
                ...roles,
                [role]: currentTarget.checked
            };
            setDisplayRoles(newRoles);
            onRolesChange(newRoles);
        }
    };

    return (
        <FormGroup>
            <FormControlLabel control={
                <Checkbox inputProps={{
                    "data-role": "admin"
                } as any} checked={displayRoles?.admin as boolean || false} onChange={handleCheckboxChange}/>
            } label={"Admin"}/>
            <FormControlLabel control={
                <Checkbox inputProps={{
                    "data-role": "editor"
                } as any} checked={displayRoles?.editor as boolean || false} onChange={handleCheckboxChange}/>
            } label={"Editor"}/>
            <FormControlLabel control={
                <Checkbox inputProps={{
                    "data-role": "viewer"
                } as any} checked={displayRoles?.viewer as boolean || false} onChange={handleCheckboxChange}/>
            } label={"Viewer"}/>
            <FormControlLabel control={
                <Checkbox inputProps={{
                    "data-role": "reviewer"
                } as any} checked={displayRoles?.reviewer as boolean || false} onChange={handleCheckboxChange}/>
            } label={"Reviewer"}/>
        </FormGroup>
    );
}
const mapStateToProps = (store: never) => ({
});

export default connect(mapStateToProps, {
})(Roles);
